export function vGetLoadedVscodeNlsLanguages() { return ["de","es","fr","it","ja","ko","ru","zh-cn","zh-tw"] }
export function vLoadVscodeNls(language) { switch(language) { 
case "de": return import("@pistonite/intwc/monaco/translation-de")
case "es": return import("@pistonite/intwc/monaco/translation-es")
case "fr": return import("@pistonite/intwc/monaco/translation-fr")
case "it": return import("@pistonite/intwc/monaco/translation-it")
case "ja": return import("@pistonite/intwc/monaco/translation-ja")
case "ko": return import("@pistonite/intwc/monaco/translation-ko")
case "ru": return import("@pistonite/intwc/monaco/translation-ru")
case "zh-cn": return import("@pistonite/intwc/monaco/translation-zh-cn")
case "zh-tw": return import("@pistonite/intwc/monaco/translation-zh-tw")
default: return Promise.resolve(undefined) } }